// LB-67 / LB-68 — the single place that decides whether a premium feature is available.
//
// Modelled on src/lib/coachEnabled.js, and for the same reason: a flag read at many sites is a
// flag that cannot be flipped safely. Learning Coach was read at 23 places before LB-269 pulled
// it into one function; premium starts with one function so it never gets there.
//
// TWO QUESTIONS, deliberately separate, because the surfaces need different answers:
//
//   premiumEntitled(settings) — has this household PAID? Today that is nobody: nothing writes
//     settings.premium yet (LB-68 is the entitlement work). Unset reads as not entitled.
//
//   premiumUnlocked(settings) — can this household USE premium features right now? True for
//     everyone while the Preview runs, because LB-277 promises exactly that: "all features,
//     including premium ones, are free to use during the Preview".
//
// So a gate asks premiumUnlocked, and an upgrade prompt asks premiumEntitled. Getting those the
// wrong way round would either charge during the Preview or nag people who have already paid.
//
// WHEN THE PREVIEW ENDS: flip PREMIUM_FREE_DURING_PREVIEW to false and release. Every premium
// feature starts gating at the same moment, which is the only way the month's notice in LB-277
// can be an honest promise — a staggered rollout would mean some families lose things on
// different days with one announcement covering all of it. Nothing is persisted to any
// household, so it is reversible by releasing again.
export const PREMIUM_FREE_DURING_PREVIEW = true;

export function premiumEntitled(settings) {
  return settings?.premium === true;
}

export function premiumUnlocked(settings) {
  return PREMIUM_FREE_DURING_PREVIEW || premiumEntitled(settings);
}
